import { render } from "./SelectedFiles.vue?vue&type=template&id=441f510c&scoped=true"
import script from "./SelectedFiles.vue?vue&type=script&lang=js"
export * from "./SelectedFiles.vue?vue&type=script&lang=js"

import "./SelectedFiles.vue?vue&type=style&index=0&id=441f510c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441f510c"]])

export default __exports__